import React, { useState } from 'react';
import { X } from 'lucide-react';
type Category = 'Alle' | 'Business' | 'Architektur' | 'Food' | 'Beauty' | 'Travel' | 'Drone';
interface PortfolioItem {
  id: number;
  src: string;
  category: Exclude<Category, 'Alle'>;
  title: string;
}
const portfolioItems: PortfolioItem[] = [{
  id: 1,
  src: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=800&q=80',
  category: 'Business',
  title: 'Corporate Portrait'
}, {
  id: 2,
  src: 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=800&q=80',
  category: 'Architektur',
  title: 'Modern Office'
}, {
  id: 3,
  src: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=800&q=80',
  category: 'Food',
  title: 'Gourmet Dish'
}, {
  id: 4,
  src: 'https://images.unsplash.com/photo-1522075469751-3a3694c2dd77?auto=format&fit=crop&w=800&q=80',
  category: 'Business',
  title: 'Team Meeting'
}, {
  id: 5,
  src: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=800&q=80',
  category: 'Beauty',
  title: 'Skincare Campaign'
}, {
  id: 6,
  src: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?auto=format&fit=crop&w=800&q=80',
  category: 'Travel',
  title: 'Swiss Alps'
}, {
  id: 7,
  src: 'https://images.unsplash.com/photo-1473186578172-c141e6798cf4?auto=format&fit=crop&w=800&q=80',
  category: 'Drone',
  title: 'Aerial View'
}, {
  id: 8,
  src: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=800&q=80',
  category: 'Business',
  title: 'Executive Headshot'
}, {
  id: 9,
  src: 'https://images.unsplash.com/photo-1600607686527-6fb886090705?auto=format&fit=crop&w=800&q=80',
  category: 'Architektur',
  title: 'Interior Design'
}];
const categories: Category[] = ['Alle', 'Business', 'Architektur', 'Food', 'Beauty', 'Travel', 'Drone'];
export function Portfolio() {
  const [activeFilter, setActiveFilter] = useState<Category>('Alle');
  const [selectedImage, setSelectedImage] = useState<PortfolioItem | null>(null);
  const filteredItems = activeFilter === 'Alle' ? portfolioItems : portfolioItems.filter(item => item.category === activeFilter);
  return <section id="portfolio" className="py-20 bg-white" data-id="element-84">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="text-center mb-12" data-id="element-86">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-id="element-87">
            Portfolio
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-88">
            Ein Einblick in meine Arbeiten aus verschiedenen Bereichen.
          </p>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-89">
          {categories.map(category => <button key={category} onClick={() => setActiveFilter(category)} className={`
                px-4 py-2 rounded-full text-sm font-medium transition-all duration-300
                ${activeFilter === category ? 'bg-[#D4A574] text-white shadow-md' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}
              `} data-id="element-90">
              {category}
            </button>)}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-91">
          {filteredItems.map(item => <div key={item.id} className="group relative aspect-[4/3] cursor-pointer overflow-hidden rounded-lg bg-gray-100" onClick={() => setSelectedImage(item)} data-id="element-92">
              <img src={item.src} alt={item.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-93" />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-94">
                <span className="text-white font-medium text-lg tracking-wide border border-white px-4 py-2" data-id="element-95">
                  Ansehen
                </span>
              </div>
            </div>)}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4" onClick={() => setSelectedImage(null)} data-id="element-96">
          <button className="absolute top-4 right-4 text-white hover:text-gray-300 focus:outline-none" onClick={() => setSelectedImage(null)} data-id="element-97">
            <X className="h-8 w-8" data-id="element-98" />
          </button>

          <div className="relative max-w-5xl max-h-[90vh] w-full" onClick={e => e.stopPropagation()} data-id="element-99">
            <img src={selectedImage.src.replace('w=800', 'w=1600')} alt={selectedImage.title} className="w-full h-full object-contain max-h-[85vh] rounded-sm" data-id="element-100" />
            <div className="mt-4 text-center text-white" data-id="element-101">
              <h3 className="text-xl font-medium" data-id="element-102">{selectedImage.title}</h3>
              <p className="text-gray-400 text-sm" data-id="element-103">{selectedImage.category}</p>
            </div>
          </div>
        </div>}
    </section>;
}